import { Component } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';

@Component({
    selector: 'app-terms',
    templateUrl: './terms.component.html',
    styleUrls: ['./terms.component.scss'],
    standalone: false
})
export class TermsComponent {
  constructor(private titleService: Title, private metaService: Meta) {
    this.titleService.setTitle('Términos de Servicio | Innovadoc IA');
    this.metaService.updateTag({ name: 'description', content: 'Consulta los términos y condiciones de uso de Innovadoc IA. Conoce tus derechos y obligaciones.' });
    this.metaService.updateTag({ name: 'robots', content: 'index, follow' });
  }
}
